module.exports = __webpack_public_path__ + "static/media/DIS_DOCUMENT_REQUIRED.0bfbf410.svg";